// Central place to interact with the Recipe AI backend + persist auth.
// Designed to be extended (favorites, meal planner, PDF export, etc.) without
// rewriting existing pages.
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;
export const RECIPE_API = `${API}/recipes`;

const TOKEN_KEY = "cc_recipe_token";
const USER_KEY = "cc_recipe_user";

// ---- Session persistence ----
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const getStoredUser = () => {
  try {
    return JSON.parse(localStorage.getItem(USER_KEY) || "null");
  } catch {
    return null;
  }
};
export const setSession = (token, user) => {
  if (token) localStorage.setItem(TOKEN_KEY, token);
  if (user) localStorage.setItem(USER_KEY, JSON.stringify(user));
};
export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
};

// ---- Authed axios instance ----
const authed = () => {
  const token = getToken();
  return axios.create({
    baseURL: RECIPE_API,
    headers: token ? { Authorization: `Bearer ${token}` } : {},
  });
};

// ---- API surface ----
export const recipeApi = {
  // Payment
  createCheckout: (email) =>
    axios.post(`${RECIPE_API}/checkout`, {
      origin_url: window.location.origin,
      email: email || undefined,
    }),
  checkoutStatus: (sessionId) =>
    axios.get(`${RECIPE_API}/checkout/status/${sessionId}`),

  // Auth
  register: (email, password, session_id) =>
    axios.post(`${RECIPE_API}/auth/register`, { email, password, session_id }),
  login: (email, password) =>
    axios.post(`${RECIPE_API}/auth/login`, { email, password }),
  me: () => authed().get("/auth/me"),

  // Library (public — no auth needed to preview)
  library: (category, limit = 60) =>
    axios.get(`${RECIPE_API}/library`, { params: { category, limit } }),
  libraryRecipe: (id) => axios.get(`${RECIPE_API}/library/${id}`),

  // Recipes AI (protected)
  generate: (body) => authed().post("/generate", body),
  makeItHealthy: (body) => authed().post("/make-it-healthy", body),
  myRecipes: (limit = 30) => authed().get("/my-recipes", { params: { limit } }),
};

export const RECIPE_CATEGORIES = [
  { key: "breakfast", label: "High Protein Breakfast" },
  { key: "dessert", label: "Healthy Desserts" },
  { key: "lunch_dinner", label: "Lunch & Dinner" },
  { key: "snack", label: "Snacks" },
  { key: "drink", label: "Drinks" },
  { key: "meal_prep", label: "Meal Prep" },
];
